// extracted by mini-css-extract-plugin
export default {"optionsButton":"styles_optionsButton__jhxft","menuButton":"styles_menuButton__B4rhx"};